module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_etgames.89ce6d218a0b9ad15913ac3e111ccd61.png";